
      <mat-toolbar>
        <span>Cash Bank Entry</span>
        <span class="fill-remaining-space"></span>
        <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
      </mat-toolbar>
    
    
    <form [formGroup]="cash_bankForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="normal-form">
      <mat-grid-list cols="1" rowHeight="520px">
        <mat-grid-tile> 
          <div class="controles-container">
            <mat-form-field>
              <input  type="text" readonly  formControlName="transNo" matInput placeholder="Transaction No"> 
              <mat-error>Transaction Number is required</mat-error>                               
              </mat-form-field>
              <mat-form-field>
                <mat-select  formControlName="transType" placeholder="Transaction Type">
                  <mat-option>Select</mat-option> 
                  <ng-container *ngFor="let item of TRANS_TYPE">
                    <mat-option  value="{{item.value}}">
                      {{item.value}}
                    </mat-option>
                  </ng-container>                  
                </mat-select>
                <mat-error>Transaction Type is required</mat-error>   
              </mat-form-field> 
              <mat-form-field>
                <mat-select  formControlName="fromAccount" placeholder="From Account">
                  <mat-option>Select</mat-option> 
                  <ng-container *ngFor="let item of bankAccountList">
                    <mat-option  value="{{item.AccountName}}">
                      {{item.AccountName}}
                    </mat-option>
                  </ng-container>                  
                </mat-select>
                <mat-error>From Account is required</mat-error>   
              </mat-form-field>   
              <mat-form-field>
                <mat-select  formControlName="toAccount" placeholder="To Account">
                  <mat-option>Select</mat-option> 
                  <ng-container *ngFor="let item of bankAccountList">
                    <mat-option  value="{{item.AccountName}}">
                      {{item.AccountName}}
                    </mat-option>
                  </ng-container>                  
                </mat-select>
                <mat-error>To Account is required</mat-error>
              </mat-form-field> 
              <mat-form-field>
                <input  type="text"  formControlName="description" matInput placeholder="Description">                              
                </mat-form-field>
                <mat-form-field>
                  <input  type="text"    formControlName="amount" matInput placeholder="Amount"> 
                  <mat-error>  Amount  is required</mat-error>                               
                  </mat-form-field>
                  <mat-form-field>
                    <input  formControlName="transDate" matInput [matDatepicker]="picker" placeholder="Date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error>Transaction Date  is required</mat-error>     
                    </mat-form-field>    
            <div class="button-row">
              <button *ngIf="crud_access.create"  type="button" mat-raised-button color="warn"  class="mr-2" (click)="newButtonClick()">New</button>              
                <button *ngIf="crud_access.create"  [disabled]="isSaveBtnDisabled" mat-raised-button color="primary" type="submit">
                  <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  Save
                </button>      
              </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
     


 
        
        
        



